import { useTheme } from 'styled-components';
import { useQuery } from '@apollo/client';
import { useLocation, useNavigate } from 'react-router-dom';
import { SectionItem } from '../components/Chrome';
import Keybind from '../components/Keybind';
import Loader from '../components/Loader';
import { Modal, ModalExit, ModalName, ModalPart } from '../components/Modal';
import { SPACE, VIEWER } from '../utilities/queries';

const KeyboardShortcutsModal = () => {
  const theme = useTheme();

  const location = useLocation();
  const navigate = useNavigate();
  const { loading: loadingSpace, data: dataSpace } = useQuery(SPACE, {
    variables: {
      slug: location.state?.fromSpace,
    },
  });
  const { loading: loadingViewer, data: dataViewer } = useQuery(VIEWER, {
    skip: !localStorage.getItem('token'),
  });

  const close = () => {
    if (location.state?.inApp) {
      navigate(-1);
    } else {
      navigate('/login');
    }
  };

  const PaddedSectionItem = ({ children, ...props }) => (
    <SectionItem isPadded {...props}>
      {children}
    </SectionItem>
  );

  return (
    <Modal onClose={() => close()} style={{ position: 'fixed' }}>
      {loadingSpace || loadingViewer ? (
        <ModalPart>
          <Loader />
        </ModalPart>
      ) : (
        <>
          <ModalExit />
          <ModalName>Keyboard shortcuts</ModalName>
          <PaddedSectionItem isWell style={{ boxShadow: theme.shadows.bottom }}>
            General
          </PaddedSectionItem>
          <PaddedSectionItem>
            <span>Open this modal</span>
            <Keybind>?</Keybind>
          </PaddedSectionItem>
          <PaddedSectionItem>
            <span>Close (topic, drawer, modal)</span>
            <Keybind>Escape</Keybind>
          </PaddedSectionItem>
          <PaddedSectionItem>
            <span>Focus</span>
            <Keybind>Tab</Keybind>
          </PaddedSectionItem>
          <PaddedSectionItem>
            <span>Move focus up (drawer)</span>
            <Keybind>↑</Keybind>
          </PaddedSectionItem>
          <PaddedSectionItem>
            <span>Move focus down (drawer)</span>
            <Keybind>↓</Keybind>
          </PaddedSectionItem>
          <PaddedSectionItem>
            <span>Move focus left (picker)</span>
            <Keybind>←</Keybind>
          </PaddedSectionItem>
          <PaddedSectionItem>
            <span>Move focus right (picker)</span>
            <Keybind>→</Keybind>
          </PaddedSectionItem>
          <PaddedSectionItem>
            <span>Move focus to first item (drawer, picker)</span>
            <Keybind>home</Keybind>
          </PaddedSectionItem>
          <PaddedSectionItem>
            <span>Move focus to last item (drawer, picker)</span>
            <Keybind>end</Keybind>
          </PaddedSectionItem>
          {dataViewer && !location.state?.fromSettings && (
            <PaddedSectionItem>
              <span>Toggle space switcher</span>
              <Keybind>!</Keybind>
            </PaddedSectionItem>
          )}
          {location.state?.fromSpace && (
            <>
              <PaddedSectionItem isWell>Space</PaddedSectionItem>
              <PaddedSectionItem>
                <span>Open home page</span>
                <Keybind>h</Keybind>
              </PaddedSectionItem>
            </>
          )}
          {dataSpace && dataSpace?.space?.role && (
            <>
              {dataSpace.space.role === 'ADMIN' && (
                <PaddedSectionItem>
                  <span>Open settings page</span>
                  <Keybind>s</Keybind>
                </PaddedSectionItem>
              )}
              <PaddedSectionItem>
                <span>Open search modal</span>
                <Keybind>/</Keybind>
              </PaddedSectionItem>
              {dataSpace.space.role === 'ADMIN' && (
                <PaddedSectionItem>
                  <span>Open invite link modal</span>
                  <Keybind>i</Keybind>
                </PaddedSectionItem>
              )}
              <PaddedSectionItem>
                <span>New topic</span>
                <Keybind>n</Keybind>
              </PaddedSectionItem>
              {location.state?.fromTopic && (
                <>
                  <PaddedSectionItem isWell>Topic</PaddedSectionItem>
                  <PaddedSectionItem>
                    <span>Edit</span>
                    <Keybind>e</Keybind>
                  </PaddedSectionItem>
                  <PaddedSectionItem>
                    <span>Archive</span>
                    <Keybind>a</Keybind>
                  </PaddedSectionItem>
                  <PaddedSectionItem>
                    <span>Reply</span>
                    <Keybind>r</Keybind>
                  </PaddedSectionItem>
                </>
              )}
            </>
          )}
          {dataViewer && dataViewer.viewer && (
            <>
              <PaddedSectionItem isWell>Account</PaddedSectionItem>
              <PaddedSectionItem>
                <span>Log out</span>
                <Keybind>v + l</Keybind>
              </PaddedSectionItem>
              <PaddedSectionItem>
                <span>Toggle night mode</span>
                <Keybind>v + n</Keybind>
              </PaddedSectionItem>
              <PaddedSectionItem>
                <span>Open settings page</span>
                <Keybind>v + s</Keybind>
              </PaddedSectionItem>
            </>
          )}
        </>
      )}
    </Modal>
  );
};

export default KeyboardShortcutsModal;
